const { Tooltip, Modal } = require("bootstrap");

const HISTORY_KEY = 'adresHistory';

const adresForm = document.getElementById('adresForm');
const tabs = document.getElementById("adresTabs");
const contents = document.getElementById("adresTabContent");

const pandColors = ['red', 'blue', 'yellow', 'green', 'purple', 'orange'];

let highlightLines = [];
let highlightLinesPoints = [];

let adressen = [];
let activeAdresIndex = 0;

let submitDisabled = false;
const opvraagButton = document.getElementById('opvraagButton');

const INFO_ICON_SVG = `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" focusable="false" style="display:block">
    <circle cx="10" cy="10" r="10" fill="#4da3ff"/>
    <circle cx="10" cy="5.8" r="1.2" fill="#ffffff"/>
    <rect x="9.1" y="8.2" width="1.8" height="6.4" rx="0.9" fill="#ffffff"/>
</svg>`;

proj4.defs("EPSG:28992", "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs");
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

let luchtfotoLaag;
let map = L.map("kaart", { renderer: L.canvas() });
//let polygonLayerGroup = L.layerGroup().addTo(map);
//let featureGroup = L.featureGroup().addTo(map);

const polygonGroups = [];

const apiKey = "l74584c680e831423ab5db31e7141e57df"; // Vul hier je BAG API key in

const structuur = {
    "Bagviewer": [
        //{ "id": "Kaart", "datapath": "" },
        { "id": "Adres", "datapath": "_embedded.adressen[0].adresregel5" },
        { "id": "Postcode", "datapath": "_embedded.adressen[0].postcode" },
        { "id": "Plaats", "datapath": "_embedded.adressen[0].woonplaatsNaam" },
        { "id": "Gemeente", "datapath": "_embedded.adressen[0]._embedded.woonplaats._links.bronhouders[0].href", "datapath2": "bronhouder.naam" },
        { "id": "Oppervlakte Gebouw", "datapath": "_embedded.adressen[0]._embedded.adresseerbaarObject.verblijfsobject.verblijfsobject.oppervlakte", "eenheid": " m2" },
        { "id": "Hoogte Gebouw", "datapath" : "" },
        { "id": "Gebruiksdoel", "datapath": "_embedded.adressen[0]._embedded.adresseerbaarObject.verblijfsobject.verblijfsobject.gebruiksdoelen" },
        { "id": "Oorspronkelijk Bouwjaar", "datapath": "_embedded.adressen[0]._embedded.panden[0].pand.oorspronkelijkBouwjaar" }
    ],
    "EpOnline": [
        //{ "id": "Registratienummer", "datapath": "???" },
        { "id": "Bag Verblijfsobject Id", "datapath": "BAGVerblijfsobjectID" },
        { "id": "Bag Pand Id", "datapath": "BAGPandIDs[]" },
        //{ "id": "ProvisionalId", "datapath": "???" },
        { "id": "Energie Index", "datapath": "EnergieIndex" },
        { "id": "Energie Index Forfaitair", "datapath": "EnergieIndex_EMG_forfaitair" },
        { "id": "Labelklasse", "datapath": "Energieklasse" },
        { "id": "Status", "datapath": "Status" },
        { "id": "Registratiedatum", "datapath": "Registratiedatum" },
        { "id": "Opnamedatum", "datapath": "Opnamedatum" },
        { "id": "Geldig Tot", "datapath": "Geldig_tot" },
        { "id": "Certificaathouder", "datapath": "Certificaathouder" },
        //{ "id": "Ingetrokken", "datapath": "???" },
        { "id": "Soort Opname", "datapath": "Soort_opname" },
        { "id": "Berekening Volgens", "datapath": "Berekeningstype" },
        { "id": "Gebr Opp Thermische Zone", "datapath": "Gebruiksoppervlakte_thermische_zone", "eenheid": " m2" },
        { "id": "Energiebehoefte", "datapath": "Energiebehoefte", "eenheid": " kWh/m2.jr" },
        { "id": "Primair Fossiel Energiegebruik", "datapath": "Primaire_fossiele_energie_EMG_forfaitair", "eenheid" : " kWh/m2.jr" },
        { "id": "Aandeel Hernieuwbare Energie", "datapath": "Aandeel_hernieuwbare_energie", "eenheid": " %" },
        { "id": "Aandeel Her Energie Emg Forf", "datapath": "Aandeel_hernieuwbare_energie_EMG_forfaitair" },
        { "id": "Temperatuur Overschrijding", "datapath": "Temperatuuroverschrijding", "eenheid": " &#8451;" },
        { "id": "Warmtebehoefte", "datapath": "Warmtebehoefte", "eenheid": " kWh/m2.jr" }
    ]
};

function createMonumentenUrl(tbody, plaats, adres, postcode, huisletter = '', huisnummertoevoeging = '') {
    
    let url = `https://www.monumenten.nl/monumenten?q=${encodeURIComponent(adres)}`;
    if (huisletter != '') {
        url += `%20${encodeURIComponent(huisletter)}`;
    }
    if (huisnummertoevoeging != '') {
        url += `%20${encodeURIComponent(huisnummertoevoeging)}`;
    }
    postcode = postcode.replace(/^\s*(\d{4})\s*([a-zA-Z]{2})\s*$/, '$1 $2').toUpperCase();
    url += `%20${encodeURIComponent(postcode)}%20${encodeURIComponent(plaats)}`;

    const row = jQuery("<tr></tr>");
    row.append(jQuery("<td></td>").text('Monument'));
    row.append(jQuery("<td></td>").html(`<a href="${url}" target="_blank">Link openen</a>`));
    tbody.append(row);
}

function createWOZUrl(tbody, postcode, huisnummer, huisletter = '', huisnummertoevoeging = '') {
    let url = `https://www.wozwaardeloket.nl/?locatie=${encodeURIComponent(postcode)}%20${encodeURIComponent(huisnummer)}`;
    if (huisletter != '') {
        url += `%20${encodeURIComponent(huisletter)}`;
    }
    if (huisnummertoevoeging != '') {
        url += `%20${encodeURIComponent(huisnummertoevoeging)}`;
    }
    const row = jQuery("<tr></tr>");
    row.append(jQuery("<td></td>").text('WOZ'));
    row.append(jQuery("<td></td>").html(`<a href="${url}" target="_blank">Link openen</a>`));
    tbody.append(row);
}

function createBag3DViewerUrl(tbody, x, y) {
    let url = `https://3dbag.nl/en/viewer?rdx=${x}&rdy=${y}&ox=40&oy=40&oz=40`;
    const row = jQuery("<tr></tr>");
    row.append(jQuery("<td></td>").text('BAG 3D Viewer'));
    row.append(jQuery("<td></td>").html(`<a href="${url}" target="_blank">Link openen</a>`));
    tbody.append(row);
}


function setTableValue(tbody, label, value) {
    if (value != "Onbekend") {
        const row = jQuery("<tr></tr>");
        row.append(jQuery("<td></td>").text(label));
        row.append(jQuery("<td></td>").html(value));
        tbody.append(row);
    }
}

function replaceTableValue(tbody, label, value) {
    const tr = tbody.find('tr').filter(function() {
        return jQuery(this).find('td').eq(0).text().trim() === label;
    }).first();

    if(tr.length) {
        if(!value.trim()) {
            tr.remove();
        }
        else {
            tr.find('td').eq(1).text(value);
        }
    }
}

// Helperfunctie om datapad te doorlopen (ook arrays zoals veld[0])
function resolvePath(obj, path) {
    try {
        return path.split('.').reduce((acc, part) => {
            if (!acc) return undefined;
            const arrayMatch = part.match(/^(\w+)\[(\d+)\]$/);
            if (arrayMatch) {
                const [, key, index] = arrayMatch;
                return acc[key]?.[parseInt(index, 10)];
            }
            return acc[part];
        }, obj);
    } catch {
        return undefined;
    }
}

function vulJaartalDropdown(van = 2016) {
    const select = document.getElementById("luchtfoto-select");
    const huidigJaar = 2024;//new Date().getFullYear();

    for (let jaar = huidigJaar; jaar >= van; jaar--) {
        const option = document.createElement("option");
        let value = jaar + '_orthoHR';
        if (jaar < 2021) {
            value = jaar + '_ortho25';
        }
        //console.log(value);
        option.value = value;
        option.textContent = jaar;
        select.append(option);
    }

    // Selecteer standaard het laatste jaar
    if (select.options.length > 0) {
        select.value = select.options[0].value;
        wisselLuchtfotoJaartal(select.value);
    }
}

vulJaartalDropdown();




/**
 * Haal BAG-data op via de proxy, geef een volledige BAG API url (vanaf /v2/...)
 * @param {string} apiUrl - Volledige BAG API url (mag querystring bevatten)
 * @param {object} context - extra context voor logging
 */
async function getDataFromBag(apiUrl, context = {}) {
    // Detecteer het vaste deel van de BAG API
    const base = 'https://api.bag.kadaster.nl/lvbag/individuelebevragingen/v2/';
    if (!apiUrl.startsWith(base)) {
        throw new Error('Ongeldige BAG API url');
    }
    // Haal endpoint en querystring uit de url
    const rest = apiUrl.substring(base.length);
    const [endpoint, queryString] = rest.split('?');
    let proxyUrl = 'proxy/bag-proxy.php?endpoint=' + encodeURIComponent(endpoint);
    if (queryString) {
        // Voeg alle querystring parameters toe
        const params = new URLSearchParams(queryString);
        for (const [key, value] of params.entries()) {
            proxyUrl += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
    }
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            url: proxyUrl,
            method: 'GET',
            headers: {
                'X-Api-Key': apiKey,
                'Accept': 'application/hal+json'
            },
            success: function (data) {
                resolve(data);
            },
            error: function (xhr) {
                // Log error naar WordPress met URL
                logAPIError('BAG API', xhr, { ...context, url: apiUrl });
                reject(xhr);
            }
        });
    });
}

async function get3DDataFromBag(pandId) {
    const apiUrl = `proxy/3d-proxy.php?pandId=${pandId}`;
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            url: apiUrl,
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                //console.log(data);
                resolve(data);
            },
            error: function (xhr, status, error) {
                // Log error naar WordPress met URL
                logAPIError('3D BAG API', xhr, { pandId: pandId, url: apiUrl });
                reject(error);
            }
        });
    });
}
/*
async function get3DDataFromBag(pandId) {
    const apiUrl = `proxy/3d-proxy.php?pandId=${pandId}`;
    try {
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
            // Server gaf een foutcode terug (bv. 404 of 500)
            console.warn('Fout bij ophalen 3D-data:', response.status, response.statusText);
            return [];
        }

        const data = await response.json();
        console.log('3D data:', data);
        return data;

    } catch (error) {
        // Fetch of JSON parsing ging mis (netwerkfout, verkeerde JSON, enz.)
        console.error('Netwerk- of parsefout:', error);
        
        return [];
    }
}*/

async function getDataFromEP(apiUrl) {
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            url: apiUrl,
            method: 'GET',
            headers: {
                'Authorization': 'N0Q1RDJDRUI1MEQ4QTVDMTgwOEY1NzkwODE5MUQ2RjM4MDBBQzRDREM0M0FBNkYzM0JFNTg0NDg2RERFMkY0Nzg1QzVBM0JGNDg1MDc3MEFCQkE3OUFGRjk4NEEyREI5'
            },
            success: function (data) {
                resolve(data);
            },
            error: function (xhr) {
                // Log error (optioneel, EP errors zijn vaak normaal - geen label beschikbaar)
                // logAPIError('EP-Online API', xhr, {});
                resolve([]);
            }
        });
    });
}

/**
 * Log API errors naar WordPress voor monitoring
 * @param {string} apiName - Naam van de API (BAG, 3D BAG, EP-Online, etc.)
 * @param {object} error - Error object of XHR object
 * @param {object} context - Extra context info (postcode, huisnummer, url, etc.)
 */
async function logAPIError(apiName, error, context = {}) {
    // Controleer of error logging beschikbaar is
    if (typeof gebouwinformatieErrorLogger === 'undefined') {
        console.warn('Error logger niet beschikbaar');
        return;
    }

    // Bepaal error type en message
    let errorType = 'unknown';
    let errorMessage = 'Onbekende fout';
    let statusCode = 0;
    let responseBody = '';

    if (error) {
        if (error.status !== undefined) {
            // XHR error object
            statusCode = error.status;
            errorMessage = error.statusText || 'HTTP Error';
            
            // Probeer response body te lezen
            try {
                if (error.responseText) {
                    responseBody = error.responseText.substring(0, 2000); // Max 2000 chars
                } else if (error.responseJSON) {
                    responseBody = JSON.stringify(error.responseJSON).substring(0, 2000);
                }
            } catch (e) {
                // Negeer parse fouten
            }
            
            if (statusCode === 0) {
                errorType = 'network';
                errorMessage = 'Netwerkfout of CORS probleem: ' + errorMessage;
            } else if (statusCode === 408) {
                errorType = 'timeout';
                errorMessage = 'Request timeout: ' + errorMessage;
            } else if (statusCode >= 400 && statusCode < 500) {
                errorType = 'client';
                errorMessage = `Client error (${statusCode}): ` + errorMessage;
            } else if (statusCode >= 500) {
                errorType = 'server';
                errorMessage = `Server error (${statusCode}): ` + errorMessage;
            }
        } else if (error.message) {
            // JavaScript Error object
            errorMessage = error.message;
            errorType = error.name || 'javascript';
        }
    }

    // Prepareer data voor logging (zonder gevoelige informatie)
    const logData = {
        action: 'log_api_error',
        nonce: gebouwinformatieErrorLogger.nonce,
        api_name: apiName,
        error_type: errorType,
        error_message: errorMessage.substring(0, 500), // Limiteer lengte
        status_code: statusCode,
        response_body: responseBody,
        request_url: context.url || '',
        postcode: context.postcode || '',
        huisnummer: context.huisnummer || ''
    };

    // Verstuur naar server (silent fail - geen gebruiker verstoren)
    try {
        await jQuery.ajax({
            url: gebouwinformatieErrorLogger.ajaxurl,
            method: 'POST',
            data: logData,
            timeout: 5000 // Max 5 seconden wachten
        });
    } catch (loggingError) {
        // Logging gefaald - log alleen naar console
        console.error('Error logging gefaald:', loggingError);
    }
}

const $selectJaar = jQuery('#luchtfoto-select');
const $prevBtnJaar = jQuery('#prevBtn');
const $nextBtnJaar = jQuery('#nextBtn');

$selectJaar.on('change', function () {
    const jaar = jQuery(this).val();
    updateButtons();
    wisselLuchtfotoJaartal(jaar);
});

function updateButtons() {
    const selectedIndex = $selectJaar.prop('selectedIndex');
    $nextBtnJaar.prop('disabled', selectedIndex === 0);
    $prevBtnJaar.prop('disabled', selectedIndex === $selectJaar.find('option').length - 1);
}

$nextBtnJaar.on('click', function () {
    const selectedIndex = $selectJaar.prop('selectedIndex');
    if (selectedIndex > 0) {
        $selectJaar.prop('selectedIndex', selectedIndex - 1).trigger('change');
        updateButtons();
    }
});

$prevBtnJaar.on('click', function () {
    const selectedIndex = $selectJaar.prop('selectedIndex');
    const totalOptions = $selectJaar.find('option').length;
    if (selectedIndex < totalOptions - 1) {
        $selectJaar.prop('selectedIndex', selectedIndex + 1).trigger('change');
        updateButtons();
    }
});

jQuery("#downloadInfo").on('click', function () {

    const paneId = parseInt(jQuery("#adresTabs button.active:first").attr("id").replace('tab-', ''));

    var baseUrl = "https://gebouwinformatie.nl/gebouwinformatie-pdf/";
    var paramsBase = {
        postcode: adressen[paneId].postcode,
        huisnummer: adressen[paneId].huisnummer,
        huisletter: adressen[paneId].huisletter,
        huisnummertoevoeging: adressen[paneId].huisnummertoevoeging,
        titel: adressen[paneId].adres,
        gemeente: adressen[paneId].gemeente,
        gevelzijde: adressen[paneId].gevelzijde || ''
    };

    var params = Object.assign({}, paramsBase, getFormData());

    if(highlightLinesPoints && highlightLinesPoints[paneId]) {

        let p1 = leafletToRD(highlightLinesPoints[paneId].p1.lat, highlightLinesPoints[paneId].p1.lng);
        let p2 = leafletToRD(highlightLinesPoints[paneId].p2.lat, highlightLinesPoints[paneId].p2.lng);

        params.x1 = highlightLinesPoints[paneId].x1;
        params.y1 = highlightLinesPoints[paneId].y1;
        params.x2 = highlightLinesPoints[paneId].x2;
        params.y2 = highlightLinesPoints[paneId].y2;
        params.p1lat = p1[0];
        params.p1lng = p1[1];
        params.p2lat = p2[0];
        params.p2lng = p2[1];
    }

    // Converteer parameters naar query string
    //var queryString = jQuery.param(params);

    // Open URL in een nieuw venster/tabblad
    //window.open(baseUrl + "?" + queryString, "_blank");
    openPostInNewTab(baseUrl, params);

});

jQuery("#downloadTable").on('click', function () {

    const paneId = parseInt(jQuery("#adresTabs button.active:first").attr("id").replace('tab-', ''));

    var baseUrl = "https://gebouwinformatie.nl/gebouwinformatie-pdf/";
    var paramsBase = {
        postcode: adressen[paneId].postcode,
        huisnummer: adressen[paneId].huisnummer,
        huisletter: adressen[paneId].huisletter,
        huisnummertoevoeging: adressen[paneId].huisnummertoevoeging,
        titel: adressen[paneId].adres,
        gemeente: adressen[paneId].gemeente,
        gevelzijde: adressen[paneId].gevelzijde || '',
        type: 'table'
    };

    // Get table data from the selected tab (array of {position, description, value})
    const tableData = getTableData(paneId);
    var params = Object.assign({}, paramsBase);
    // Send table data as JSON so the server can reconstruct/sort it safely
    params.tableData = JSON.stringify(tableData);

    if(highlightLinesPoints && highlightLinesPoints[paneId]) {

        let p1 = leafletToRD(highlightLinesPoints[paneId].p1.lat, highlightLinesPoints[paneId].p1.lng);
        let p2 = leafletToRD(highlightLinesPoints[paneId].p2.lat, highlightLinesPoints[paneId].p2.lng);

        params.x1 = highlightLinesPoints[paneId].x1;
        params.y1 = highlightLinesPoints[paneId].y1;
        params.x2 = highlightLinesPoints[paneId].x2;
        params.y2 = highlightLinesPoints[paneId].y2;
        params.p1lat = p1[0];
        params.p1lng = p1[1];
        params.p2lat = p2[0];
        params.p2lng = p2[1];
    }

    openPostInNewTab(baseUrl, params);

});

function getTableData(paneId) {
    const rows = [];
    const tableSelector = `#resultTable${paneId}`;

    jQuery(`${tableSelector} tbody tr`).each(function(index) {
        const $row = jQuery(this);
        const $cells = $row.find('td');

        if ($cells.length >= 2) {
            const description = $cells.eq(0).text().trim();
            const $valueCell = $cells.eq(1);

            // Check for external links
            const $externalLinks = $valueCell.find('a[href]').filter(function() {
                const href = jQuery(this).attr('href');
                return href && href !== '#';
            });

            // Special handling for Bouwdossier links - include them with URL
            if (description === 'Bouwdossier' && $externalLinks.length > 0) {
                const urls = [];
                $externalLinks.each(function() {
                    const href = jQuery(this).attr('href');
                    if (href) {
                        urls.push(href);
                    }
                });
                
                if (urls.length > 0) {
                    // Send URLs separated by pipe (|) - PHP will convert to links
                    const value = urls.join('|');
                    
                    rows.push({
                        position: index,
                        description: description,
                        value: value
                    });
                }
                return;
            }

            // Skip other rows with external links
            if ($externalLinks.length > 0) {
                return; // skip
            }

            const value = $valueCell.text().trim();

            rows.push({
                position: index,
                description: description,
                value: value
            });
        }
    });

    return rows;
}

function openPostInNewTab(url, data) {
    
    var $form = jQuery('<form>', {
        action: url,
        method: 'POST',
        target: '_blank'
    });

    // Voeg data toe
    jQuery.each(data, function(name, value) {
        jQuery('<input>').attr({
            type: 'hidden',
            name: name,
            value: value
        }).appendTo($form);
    });

    // Formulier toevoegen, submitten en weer verwijderen
    $form.appendTo('body').submit().remove();
}

//$select.on('change', updateButtons);

function wisselLuchtfotoJaartal(jaartal) {
    if (luchtfotoLaag) {
        map.removeLayer(luchtfotoLaag);
    }

    const url = `https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/${jaartal}/EPSG:3857/{z}/{x}/{y}.jpeg`;
    luchtfotoLaag = L.tileLayer(url, {
        attribution: '&copy; <a href="https://www.pdok.nl">PDOK</a>',
        maxZoom: 20
    }).addTo(map);
}

// Converteer RD naar WGS84 met proj4js
function convertRDtoWGS84(x, y) {
    try {
        const rdCoords = [x, y];
        const wgs84Coords = proj4("EPSG:28992", "EPSG:4326", rdCoords);

        return [
            wgs84Coords[1],
            wgs84Coords[0]
        ];
    } catch (error) {
        console.error('Fout bij conversie:', error);
        throw new Error('Conversie van RD naar WGS84 mislukt');
    }
}

function leafletToRD(lat, lng) {
  return proj4("EPSG:4326", "EPSG:28992", [lng, lat]);
}

function parseHuisnummer(input) {
    const trimmed = input.trim();

    // Match: 123, 123a, 123 a, 123a2, 123 a 2, etc.
    const regex = /^(\d+)\s*([a-zA-Z]?)\s*([^\s]*)?$/;
    const match = trimmed.match(regex);

    if (!match) {
        return {
            huisnummer: '',
            letter: '',
            toevoeging: ''
        };
    }

    return {
        huisnummer: match[1] || '',
        letter: match[2] || '',
        toevoeging: match[3] || ''
    };
}

function debounce(fn, ms = 300) { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; }

const input = document.getElementById('adres');
const list = document.getElementById('suggesties');
const clearBtn = document.getElementById('clearAdres');
const hPost = document.querySelector('[name=postcode]');
const hNum = document.querySelector('[name=huisnummer]');
const hLet = document.querySelector('[name=huisletter]');
const hToev = document.querySelector('[name=huisnummertoevoeging]');

let current = -1, hits = [], selected = false;

// Toggle clear button visibility
function toggleClearButton() {
    if (clearBtn) {
        clearBtn.classList.toggle('show', input.value.length > 0);
    }
}

// Clear input and hidden fields
function clearInputFields() {
    input.value = '';
    clearForm();
    list.classList.add('hidden');
    list.innerHTML = '';
    hits = [];
    current = -1;
    toggleClearButton();
    input.focus();
}

// Event listeners voor clear button
if (clearBtn) {
    clearBtn.addEventListener('click', clearInputFields);
}

if (input) {
    input.addEventListener('input', toggleClearButton);
    // Initial check
    toggleClearButton();
}

const fetchSuggest = debounce(async q => {
    if (q.length < 3) { list.classList.add('hidden'); return; }
    const url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/suggest?q=' + encodeURIComponent(q)
        + '&rows=8&fq=type:(adres)&fl=id,weergavenaam';
    const js = await (await fetch(url)).json();
    hits = js.response?.docs ?? []; current = -1; renderList();

    ////if(q.length < 3){ renderList(true); return; }
    ////const url='https://api.pdok.nl/bzk/locatieserver/search/v3_1/suggest?q='+encodeURIComponent(q)
    ////        +'&rows=8&fq=type:(adres)&fl=id,weergavenaam';
    ////const js = await (await fetch(url)).json();
    ////hits = js.response?.docs ?? [];
    ////renderList(true);   // combineer history + nieuwe hits

}, 250);

function renderList() {
    list.innerHTML = hits.map((h, i) => `<li data-idx="${i}" ${i === current ? 'class="active"' : ''}>${h.weergavenaam}</li>`).join('');
    list.classList.toggle('hidden', hits.length === 0);
}

/* -------- renderlijst: combineer history + hits -------- */
////function renderList(showHistoryFirst = false){
////  const history = showHistoryFirst ? loadHistory() : [];
////  const combined = [...history, ...hits];   // history bovenaan
////  list.innerHTML = combined.map((h,i)=>
////    `<li data-idx="${h.id}">${h.weergavenaam}</li>`
////  ).join('');
////  list.classList.toggle('hidden', combined.length===0);
////  // sla de gecombineerde lijst tijdelijk op voor selectie
////  list.dataset.items = JSON.stringify(combined);
////}

async function selectHit(idx) {
    clearForm();

    const id = encodeURIComponent(hits[idx].id);
    const url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/lookup?id=' + id
        + '&fl=weergavenaam,postcode,huisnummer,huisletter,huisnummertoevoeging';
    const js = await (await fetch(url)).json();
    const d = js.response?.docs?.[0]; if (!d) return;

    input.value = d.weergavenaam;
    hPost.value = d.postcode;
    hNum.value = d.huisnummer;
    hLet.value = d.huisletter || '';
    hToev.value = d.huisnummertoevoeging || '';

    // toevoegen aan history
    addToHistory({ id, weergavenaam: d.weergavenaam });

    /* ---- dropdown opruimen ---- */
    list.classList.add('hidden');
    list.innerHTML = '';
    hits = [];
    current = -1;
    selected = true;             // markeer dat er nu wél gekozen is

    //if(adresForm.requestSubmit){ adresForm.requestSubmit(); } else { adresForm.submit(); }
}

input.addEventListener('focus', ()=>{
  if(input.value.trim()===''){ renderList(true); }
});

input.addEventListener('input', e => {
    //selected = false;            // reset vlag
    //fetchSuggest(e.target.value);
    selected=false;
    const q = e.target.value.trim();
    if(q===''){ 
        renderList(true); 
    }
    else { 
        fetchSuggest(q); 
    }
});

input.addEventListener('keydown', async e => {
    const max = hits.length - 1;
    if (e.key === 'ArrowDown') { current = current < max ? current + 1 : 0; renderList(); e.preventDefault(); }
    if (e.key === 'ArrowUp') { current = current > 0 ? current - 1 : max; renderList(); e.preventDefault(); }
    if (e.key === 'Enter' && current > -1) { e.preventDefault(); await selectHit(current); if (adresForm.requestSubmit) { adresForm.requestSubmit(); } else { adresForm.submit(); } }
});

list.addEventListener('mousedown', async e => {
    const li = e.target.closest('li[data-idx]'); 
    if (li) { await selectHit(+li.dataset.idx); } if (adresForm.requestSubmit) { adresForm.requestSubmit(); } else { adresForm.submit(); }
});



adresForm.addEventListener('submit', async e => {
    if (submitDisabled == false) {
        disableForm();

        e.preventDefault();                   // stuur nog NIET weg
        if (!selected && hits.length) {           // nog niets gekozen?
            await selectHit(0);                   // kies 1e suggestie
        }

        polygonGroups.forEach(group => {
            if (map.hasLayer(group)) {
                map.removeLayer(group);
            }
        });
        highlightLines.forEach(line => {
            if (line) {
                map.removeLayer(line);
            }
        });
        polygonGroups.length = 0;
        adressen = [];
        highlightLines = [];
        highlightLinesPoints = [];
        jQuery('#angle-image').hide();
        jQuery('#angle-info').addClass('d-none').hide();

        let postcode = jQuery('#postcode').val();
        let huisnummer = jQuery('#huisnummer').val();
        let huisletter = jQuery('#huisletter').val();
        let huisnummertoevoeging = jQuery('#huisnummertoevoeging').val();

        let additionalUrlParameters = '';
        if (typeof huisletter !== 'undefined' && huisletter != "") {
            additionalUrlParameters += `&huisletter=${huisletter}`;
        }
        if (typeof huisnummertoevoeging !== 'undefined' && huisnummertoevoeging != "") {
            additionalUrlParameters += `&huisnummertoevoeging=${huisnummertoevoeging}`;
        }

        let bagData;
        try {
            bagData = await getDataFromBag(
                `https://api.bag.kadaster.nl/lvbag/individuelebevragingen/v2/adressen?postcode=${postcode}&huisnummer=${huisnummer}&expand=true&inclusiefEindStatus=false` + additionalUrlParameters,
                { postcode: postcode, huisnummer: huisnummer }
            );
        } catch (error) {
            console.error('Error fetching BAG data:', error);
            // Error is al gelogd in getDataFromBag functie
            showError('Er is een probleem opgetreden bij het ophalen van de gegevens. Probeer het later opnieuw.');
            enableForm();
            return;
        }

        if (bagData && bagData._embedded && bagData._embedded.adressen.length > 0) {
            //console.log(bagData);

            tabs.innerHTML = '';
            contents.innerHTML = '';

            //polygonLayerGroup.clearLayers();
            //featureGroup.clearLayers();
            let pandCoordsIndex = 0;
            let pandColor = '';


            let adresText = `${huisnummer}`;
            const numberOfAdressen = bagData._embedded.adressen.length;

            let gemeenteText = '';
            let gemeenteLinks = '';

            for (let adresIndex = 0; adresIndex < numberOfAdressen; adresIndex++) {
                const panelTable = jQuery("#tableTemplate table:first").clone();
                panelTable.attr('id', 'resultTable' + adresIndex);
                const tbody = panelTable.find('tbody');

                additionalUrlParameters = '';
                huisletter = resolvePath(bagData, '_embedded.adressen[' + adresIndex + '].huisletter');
                if (typeof huisletter !== 'undefined' && huisletter != "") {
                    additionalUrlParameters += `&huisletter=${huisletter}`;
                    adresText += ` ${huisletter}`;
                }
                huisnummertoevoeging = resolvePath(bagData, '_embedded.adressen[' + adresIndex + '].huisnummertoevoeging');
                if (typeof huisnummertoevoeging !== 'undefined' && huisnummertoevoeging != "") {
                    additionalUrlParameters += `&huisnummertoevoeging=${huisnummertoevoeging}`;
                    adresText += ` ${huisnummertoevoeging}`;
                }

                for (const item of structuur.Bagviewer) {

                    const label = item.id.replace(/\./g, "");
                    const path = item.datapath;

                    if(path == "")
                    {
                        setTableValue(tbody, label, "");
                        continue;
                    }
                    if (path === "???") {
                        setTableValue(tbody, label, "Ongeldige parameter");
                        continue;
                    }

                    let waarde = resolvePath(bagData, path.replace('adressen[0]', 'adressen[' + adresIndex + ']'));

                    if (typeof waarde === "string" && waarde.startsWith("http") && item.datapath2) {
                        let data2;
                        try {
                            data2 = await getDataFromBag(waarde);
                        } catch (error) {
                            console.error('Error fetching extra BAG data:', error);
                            showError('Er is een probleem opgetreden bij het ophalen van extra BAG-gegevens. Probeer het later opnieuw.');
                            enableForm();
                            return;
                        }
                        waarde = resolvePath(data2, item.datapath2);
                        if (item.id == "Gemeente" && waarde && waarde.trim() != "") {
                            let gemeenteCode = resolvePath(data2, "bronhouder.code");

                            const gemeenteItem = window.gemeenteData.find(
                                item => String(item.gemeente_code) === String(gemeenteCode)
                            );

                            if (gemeenteItem && gemeenteItem.urls && gemeenteItem.urls.length > 0) {
                                //waarde = '';
                                let count = '';
                                gemeenteLinks = '';
                                for (let index = 0; index < gemeenteItem.urls.length; index++) {
                                    if (gemeenteItem.urls.length > 1) {
                                        count = (index + 1);
                                    }
                                    gemeenteLinks += `<a href="${gemeenteItem.urls[index]}" target="_blank">Link ${count} openen</a> `;
                                    
                                    gemeenteText = gemeenteItem.gemeente;
                                }
                            }
                        }

                    }

                    if (waarde === undefined || waarde === null || waarde === "") {
                        waarde = "Onbekend";
                    }
                    else if (item.eenheid !== undefined) {
                        waarde += item.eenheid;
                    }
                    setTableValue(tbody, label, waarde);
                }


                //let adressenIds = [];

                //    const adres = data._embedded.adressen[i];
                //    adressenIds.push(data._embedded.adressen[i].adresseerbaarObjectIdentificatie);
                //}

                let adresId = resolvePath(bagData, '_embedded.adressen[' + adresIndex + '].adresseerbaarObjectIdentificatie');

                if (adresId && adresId != "") {
                    additionalUrlParameters += `&adresId=${adresId}`;
                }

                const epDataPromise = getDataFromEP(`proxy/ep-proxy.php?postcode=${postcode}&huisnummer=${huisnummer}` + additionalUrlParameters);

                const locationCoords = resolvePath(bagData, '_embedded.adressen[' + adresIndex + ']._embedded.adresseerbaarObject.verblijfsobject.verblijfsobject.geometrie.punt.coordinates');
                //console.log("locationCoords:", locationCoords);


                const locationLatLon = convertRDtoWGS84(locationCoords[0], locationCoords[1]);
                //console.log(locationLatLon);

                pandColor = pandColors[pandCoordsIndex];
                const fgroup = L.featureGroup();
                // TODO: get gebouw informatie bouwjaar per gebouw, geef ieder gebouw apart aan
                let pandHoogte = 0;
                let gebouwHoogte = "";
                for (let pandIndex = 0; pandIndex < bagData._embedded.adressen[adresIndex]._embedded.panden.length; pandIndex++) {
                    const pandId = resolvePath(bagData, '_embedded.adressen[' + adresIndex + ']._embedded.panden[' + pandIndex + '].pand.identificatie');
                    
                    let pandData = null;
                    try {
                        pandData = await get3DDataFromBag(pandId);
                    } catch (error) {
                        console.warn('3D data not available for pandId:', pandId, error);
                        // Voortgang zonder hoogte-informatie
                        pandData = null;
                    }
                    
                    // Alleen hoogte berekenen als we valide data hebben
                    if (pandData && pandData.b3_h_nok !== undefined && pandData.b3_h_dak_max !== undefined && pandData.b3_h_maaiveld !== undefined) {
                        let dakHoogte = pandData.b3_h_nok ? pandData.b3_h_nok : pandData.b3_h_dak_max;

                        if(pandData.b3_h_dak_max > dakHoogte) {
                            dakHoogte = pandData.b3_h_dak_max;
                        }

                        let tempHoogte = (dakHoogte - pandData.b3_h_maaiveld).toFixed(2);
                        if(tempHoogte > pandHoogte)
                        {
                            pandHoogte = tempHoogte;
                        }
                    }
                    //console.log(pandHoogte);

                    gebouwHoogte = (pandHoogte != 0) ? (pandHoogte + " m") : "Onbekend";

                    replaceTableValue(tbody, "Hoogte Gebouw", gebouwHoogte);

                    const pandCoords = resolvePath(bagData, '_embedded.adressen[' + adresIndex + ']._embedded.panden[' + pandIndex + '].pand.geometrie.coordinates');

                    //const pandCoords = resolvePath(bagData, '_embedded.adressen['+adresIndex+']._embedded.panden[0].pand.geometrie.coordinates');
                    //const geoType = adres._embedded.panden[0].pand.geometrie.type;
                    //console.log("pandCoords:", pandCoords);
                    //polygonLayerGroup.clearLayers();

                    const polygonLatLngs = pandCoords[0].map(([x, y]) => {
                        return convertRDtoWGS84(x, y);
                        //return [lat, lng]; // Leaflet expects [lat, lng]
                    });

                    const polygon = L.polygon(polygonLatLngs, { color: pandColor, weight: 2, fillOpacity: 0.01 });

                    polygon.on("click", function (e) {

                        if (adresIndex !== activeAdresIndex) {
                            jQuery("button[id='tab-" + adresIndex + "']").trigger("click");
                        }
                        else {

                            const latlng = e.latlng;
                            const clickPoint = map.latLngToLayerPoint(latlng);

                            const latlngs = this.getLatLngs()[0];
                            let minDist = Infinity;
                            let nearestEdge = null;
                            let nearestEdgeIndex = -1;
                            const tolerance = 8; // pixels

                            for (let i = 0; i < latlngs.length; i++) {
                                const p1 = map.latLngToLayerPoint(latlngs[i]);
                                const p2 = map.latLngToLayerPoint(latlngs[(i + 1) % latlngs.length]);

                                const dist = distancePointToSegment(clickPoint, p1, p2);
                                if (dist < minDist) {
                                    minDist = dist;
                                    nearestEdge = [latlngs[i], latlngs[(i + 1) % latlngs.length]];
                                    nearestEdgeIndex = i;
                                }
                            }

                            if (minDist <= tolerance && nearestEdge) {
                                // Verwijder oude highlight
                                if (highlightLines && highlightLines[adresIndex]) {
                                    map.removeLayer(highlightLines[adresIndex]);
                                }

                                // Nieuwe dikke lijn toevoegen
                                highlightLines[adresIndex] = L.polyline(nearestEdge, {
                                    color: "orange",
                                    weight: 15,
                                    opacity: 0.9
                                }).addTo(map);

                                //console.log("Highlight toegevoegd:", nearestEdge);

                                // Hoek berekenen
                                const p1 = map.latLngToLayerPoint(nearestEdge[0]);
                                const p2 = map.latLngToLayerPoint(nearestEdge[1]);

                                //const dx = p2.x - p1.x;
                                //const dy = p2.y - p1.y;

                                //let angleDeg = Math.atan2(dy, dx) * (180 / Math.PI);

                                // Zorg dat het altijd tussen 0–180 komt
                                //angleDeg = (angleDeg + 360) % 360; // 0–360
                                //if (angleDeg > 180) {
                                    //angleDeg -= 180; // terugbrengen naar 0–180
                                //}

                                highlightLinesPoints[adresIndex] = {
                                    x1: p1.x, 
                                    y1: p1.y, 
                                    x2: p2.x, 
                                    y2: p2.y, 
                                    p1: nearestEdge[0], 
                                    p2: nearestEdge[1],
                                    adresIndex: adresIndex,
                                    edgeIndex: nearestEdgeIndex,
                                    polygonVertices: latlngs
                                };

                                showAngleImage(highlightLinesPoints[adresIndex]);

                                //alert("Hoek t.o.v. horizontaal:" + angleDeg.toFixed(2) + "°");
                                //alert("Hoek t.o.v. verticaal:" + (angleDeg - 90).toFixed(2) + "°");
                            }
                        }
                    });

                    //polygon.addTo(polygonLayerGroup);
                    fgroup.addLayer(polygon);
                    //featureGroup.addLayer(polygon);
                    //polygons.push(polygon);
                }
                fgroup.addTo(map);
                polygonGroups.push(fgroup);
                pandCoordsIndex++;

                //map = map.setView(locationLatLon, 19);

                //L.tileLayer.wms("https://service.pdok.nl/hwh/luchtfotorgb/wms/v1_0", {
                //    layers: "Actueel_orthoHR",
                //    format: "image/png",
                //    attribution: "PDOK luchtfoto"
                //}).addTo(map)

                let jaartal = jQuery("#luchtfoto-select").val();

                luchtfotoLaag = L.tileLayer(`https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/${jaartal}/EPSG:3857/{z}/{x}/{y}.jpeg`, {
                    attribution: '&copy; <a href="https://www.pdok.nl">PDOK</a>',
                    maxZoom: 20
                }).addTo(map);

                //L.polygon(polygonLatLngs, {
                //    color: "blue",
                //    weight: 2,
                //    fillOpacity: 0.3
                //.addTo(map);

                //map.fitBounds(polygonLatLngs);
                //https://public.ep-online.nl/api/v5/PandEnergielabel/Adres?postcode=6222PC&huisnummer=20
                const epData = await epDataPromise;

                if (epData) {
                    //console.log("Start");
                    for (const item of structuur.EpOnline) {
                        const label = item.id.replace(/\./g, "");
                        //console.log(label);
                        const path = item.datapath;

                        if (path === "???") {
                            setTableValue(tbody, label, "Ongeldige parameter");
                            continue;
                        }

                        let waarde = resolvePath(epData[0], path);

                        /*if (typeof waarde === "string" && waarde.startsWith("http") && item.datapath2) {
                            data2 = await getDataFromEP(waarde);
                            waarde = resolvePath(data2, item.datapath2);
                        }*/

                        if (waarde === undefined || waarde === null || waarde === "") {
                            waarde = "Onbekend";
                        }
                        else if (item.eenheid !== undefined) {
                            waarde += item.eenheid;
                        }

                        if(item.datapath == "Berekeningstype" && !waarde.startsWith("NTA 8800:2024"))
                        {
                            let title = "Dit label is opgesteld middels een achterhaalde methode";
                            if(waarde == "Onbekend") {
                                title = "Er is nog geen label beschikbaar";
                            }
                            waarde = '<a href="#" class="tooltip-item" title="'+title+'"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="orange" class="me-2" viewBox="0 0 16 16"><path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/><path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0z"/></svg></a>' + waarde;
                        }
                        setTableValue(tbody, label, waarde);
                    }
                }

                createWOZUrl(tbody, postcode, huisnummer, huisletter, huisnummertoevoeging);

                if(gemeenteLinks && gemeenteLinks != "") {
                    setTableValue(tbody, 'Bouwdossier', gemeenteLinks); 
                }
                createBag3DViewerUrl(tbody, locationCoords[0], locationCoords[1]);

                const adresStr = resolvePath(bagData, '_embedded.adressen[' + adresIndex + '].adresregel5');
                const plaatsStr = resolvePath(bagData, '_embedded.adressen[' + adresIndex + '].woonplaatsNaam');
                createMonumentenUrl(tbody, plaatsStr, adresStr, postcode, huisletter, huisnummertoevoeging);

                let adresTitel = adresStr + " " + postcode + " " + plaatsStr;

                adressen[adresIndex] = {
                    postcode: postcode,
                    huisnummer: huisnummer,
                    huisletter: huisletter,
                    toevoeging: huisnummertoevoeging,
                    adres: adresTitel,
                    gemeente: gemeenteText,
                    gebouwHoogte: gebouwHoogte,
                    gevelzijde: '',
                }

                //console.log(adressen[adresIndex]);
                const tabId = `tab-${adresIndex}`;
                const paneId = `pane-${adresIndex}`;
                const activeClass = adresIndex === 0 ? 'active' : '';
                const selected = adresIndex === 0 ? 'true' : 'false';

                // Tab knop
                tabs.innerHTML += `
            <li class="nav-item" role="presentation">
                <button class="nav-link ${activeClass} color-${pandColor}" id="${tabId}" data-bs-toggle="tab" data-bs-target="#${paneId}" type="button" role="tab" aria-controls="${paneId}" aria-selected="${selected}">
                ${adresText}
                </button>
            </li>
            `;

                // Tab inhoud
                contents.innerHTML += `
            <div class="tab-pane fade ${activeClass ? 'show active' : ''}" id="${paneId}" role="tabpanel" aria-labelledby="${tabId}">
            </div>
            `;

                jQuery('#' + paneId).append(panelTable);
                jQuery("#downloadInfo").prop('disabled', false);
                jQuery("#downloadTable").removeClass('d-none');
                jQuery("#downloadTable").prop('disabled', false);
                //jQuery('#resultTable').removeClass('d-none');
            }

            jQuery("button[id^='tab-']").on('click', function () {
                let idx = jQuery(this).attr("id");

                highlightLayer(parseInt(idx.replace('tab-', '')));
            });

            highlightLayer(0);

            let combinedBounds = L.latLngBounds();
            polygonGroups.forEach(group => {
                if (group.getBounds().isValid()) {
                    combinedBounds.extend(group.getBounds());
                }
            });

            if (combinedBounds.isValid()) {
                map.fitBounds(combinedBounds);
            }

            jQuery(".tooltip-item").each(function () {
                if (!this._tooltip) {
                    this._tooltip = new Tooltip(this);
                }
            });


            //setTimeout(() => {
            //    const currentZoom = map.getZoom();
            //    map.setZoom(currentZoom - 1); // Eén stap uitzoomen
            //}, 200);
            //map.fitBounds(featureGroup.getBounds());
        }
        else {

        }

        enableForm();
    }

});

function disableForm() {
    submitDisabled = true;
    opvraagButton.disabled = true;
    
    // Add spinner to button
    const spinner = document.createElement('span');
    spinner.id = 'opvraagSpinner';
    spinner.className = 'spinner-border spinner-border-sm me-2';
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-hidden', 'true');
    
    opvraagButton.insertBefore(spinner, opvraagButton.firstChild);
}

function enableForm() {
    setTimeout(() => {
        submitDisabled = false;
        opvraagButton.disabled = false;
        
        // Remove spinner from button
        const spinner = document.getElementById('opvraagSpinner');
        if (spinner) {
            spinner.remove();
        }
        
    }, 100);
}

function showError(message) {
    jQuery('#errorMessage').text(message);
    new Modal(jQuery('#errorModal')[0]).show();
}

function showAngleInfoPrompt() {
    jQuery('#angle-info').html(`<span class="d-inline-flex align-items-center gap-2"><span>${INFO_ICON_SVG}</span><span>Klik op een gevel voor oriëntatie informatie</span></span>`).removeClass('d-none mb-3').show();
}

function showAngleInfoSide(sideDescription) {
    jQuery('#angle-info').html(`<strong>Gevel oriëntatie:</strong> ${sideDescription}`).removeClass('d-none').addClass('mb-3').show();
}

function updateGevelzijdeForAdres(adresIndex, sideDescription) {
    if (typeof adressen[adresIndex] !== 'undefined') {
        adressen[adresIndex].gevelzijde = sideDescription;
    }

    if (adresIndex === activeAdresIndex) {
        jQuery('#gevelzijde').val(sideDescription);
    }
}

function highlightLayer(index) {
    polygonGroups.forEach((group, i) => {
        group.eachLayer(layer => {
            layer.setStyle({
                weight: i === index ? 6 : 2
            });
            //layer.bringToFront();
        });

        if(highlightLines && highlightLines[i]) {
            highlightLines[i].setStyle({
                opacity: i === index ? 0.9 : 0.5
            });
        }
        //group.forEach((poly, j) => {
        //    poly.
        //})
    });
    activeAdresIndex = index;
    
    if(adressen[activeAdresIndex] && adressen[activeAdresIndex].gebouwHoogte && adressen[activeAdresIndex].gebouwHoogte !== "Onbekend") {
        jQuery("#gebouwhoogte").val(adressen[activeAdresIndex].gebouwHoogte);
    } else {
        jQuery("#gebouwhoogte").val('');
    }
    if(adressen[activeAdresIndex]) {
        jQuery('#gevelzijde').val(adressen[activeAdresIndex].gevelzijde || '');
    }

    if(highlightLinesPoints && highlightLinesPoints[activeAdresIndex]) {
        showAngleImage(highlightLinesPoints[activeAdresIndex]);        
    }
    else {
        jQuery('#angle-image').hide();
        if (polygonGroups.length > 0) {
            showAngleInfoPrompt();
        } else {
            jQuery('#angle-info').removeClass('mb-3').addClass('d-none').hide();
        }
    }
}

function showAngleImage(anglePoints) {
    try {
        const imgUrl = `https://gebouwinformatie.nl/PDF/hoek.php?x1=${anglePoints.x1}&y1=${anglePoints.y1}&x2=${anglePoints.x2}&y2=${anglePoints.y2}`;
        //const imgUrl = `https://gebouwinformatie.nl/PDF/hoek.php?x1=${anglePoints.p1.lng}&y1=${anglePoints.p1.lat}&x2=${anglePoints.p2.lng}&y2=${anglePoints.p2.lat}`;
        jQuery('#angle-image').css({"background-image": "url('" + imgUrl + "')" }).show();
        
        // Bereken de hoek van de lijn
        const lineAngle = calculateAngleDegrees(anglePoints.x1, anglePoints.y1, anglePoints.x2, anglePoints.y2);
        
        // Bereken de normale naar buiten van het gebouw
        let outwardNormalAngle = lineAngle;
        if (anglePoints.polygonVertices && anglePoints.edgeIndex >= 0) {
            outwardNormalAngle = calculateOutwardNormal(
                anglePoints.polygonVertices,
                anglePoints.edgeIndex,
                map
            );
        }
        
        // Bepaal de windrichting op basis van de normale naar buiten
        const direction = getCompassDirection(outwardNormalAngle);
        const sideDescription = getSideDescription(outwardNormalAngle);
        const displayAngle = Math.round(getAngleRelativeToNorthSouthAxis(outwardNormalAngle));
        const selectedAdresIndex = Number.isInteger(anglePoints.adresIndex) ? anglePoints.adresIndex : activeAdresIndex;

        updateGevelzijdeForAdres(selectedAdresIndex, sideDescription);
        
        // Voeg de omschrijving toe aan de afbeelding
        jQuery('#angle-image')
            .attr('data-compass-direction', direction)
            .attr('data-side-description', sideDescription)
            .attr('data-raw-angle', outwardNormalAngle.toFixed(1))
            .attr('data-display-angle', displayAngle)
            .attr('title', `Gevel oriëntatie: ${sideDescription}`);

        showAngleInfoSide(sideDescription);
    }
    catch(error) {
        console.error("Fout bij hoekberekening:", error);
    }
}

/**
 * Berekent de normale naar buiten van een edge van een polygon
 * @param {Array} polygonVertices - Alle vertices van het polygon
 * @param {number} edgeIndex - Index van de edge
 * @param {Object} map - Leaflet map object
 * @returns {number} Hoek van de normale naar buiten in graden (0-360)
 */
function calculateOutwardNormal(polygonVertices, edgeIndex, map) {
    const v1 = polygonVertices[edgeIndex];
    const v2 = polygonVertices[(edgeIndex + 1) % polygonVertices.length];
    
    // Converteer naar pixel-coördinaten
    const p1 = map.latLngToLayerPoint(v1);
    const p2 = map.latLngToLayerPoint(v2);
    
    // Bereken de vector van de lijn
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    
    // De normale naar links (loodrecht op de lijn) - draai 90 graden tegen de klok in
    let normalX = -dy;
    let normalY = dx;
    
    // Check of het polygon tegen de klok in (CCW) is georiënteerd
    // Als niet, draai de normale om (×-1)
    if (!isPolygonCCW(polygonVertices)) {
        normalX = dy;
        normalY = -dx;
    }
    
    // Bereken de hoek van deze normale
    let angle = Math.atan2(normalY, normalX) * (180 / Math.PI);
    angle = (angle + 360) % 360;
    
    return angle;
}

/**
 * Controleert of een polygon tegen de klok in (CCW) georiënteerd is
 * @param {Array} vertices - Array van lat/lng objecten
 * @returns {boolean} True als CCW, false als CW
 */
function isPolygonCCW(vertices) {
    let area = 0;
    for (let i = 0; i < vertices.length; i++) {
        const j = (i + 1) % vertices.length;
        const v1 = vertices[i];
        const v2 = vertices[j];
        area += (v2.lat - v1.lat) * (v2.lng + v1.lng);
    }
    return area > 0;
}

/**
 * Berekent de hoek in graden tussen twee punten
 * @param {number} x1 - X-coördinaat van punt 1
 * @param {number} y1 - Y-coördinaat van punt 1
 * @param {number} x2 - X-coördinaat van punt 2
 * @param {number} y2 - Y-coördinaat van punt 2
 * @returns {number} Hoek in graden (0-360)
 */
function calculateAngleDegrees(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    
    // Bereken hoek in radialen met atan2
    let angle = Math.atan2(dy, dx) * (180 / Math.PI);
    
    // Normaliseer naar 0-360 graden
    angle = (angle + 360) % 360;
    
    return angle;
}

/**
 * Geeft de kleinste hoekafwijking t.o.v. de noord-zuid as (0-90 graden)
 * @param {number} angle - Hoek in screencoordinaten (0-360)
 * @returns {number} Hoekafwijking t.o.v. noord-zuid as (0-90)
 */
function getAngleRelativeToNorthSouthAxis(angle) {
    const normalized = (angle + 360) % 360;
    const north = 270;
    const south = 90;

    const diffNorth = Math.abs(((normalized - north + 540) % 360) - 180);
    const diffSouth = Math.abs(((normalized - south + 540) % 360) - 180);

    return Math.min(diffNorth, diffSouth);
}

/**
 * Zet een hoek in graden om naar een kompaalpunt-omschrijving
 * @param {number} angle - Hoek in graden (0-360)
 * @returns {string} Kompaalpunt-omschrijving (N, NO, O, ZO, Z, ZW, W, NW)
 */
function getCompassDirection(angle) {
    // Normaliseer de hoek naar 0-360
    angle = (angle + 360) % 360;
    
    // Verdeel in 8 sectoren van elk 45 graden
    // In screencoördinaten: 0°=O, 90°=Z, 180°=W, 270°=N
    const directions = ['O', 'ZO', 'Z', 'ZW', 'W', 'NW', 'N', 'NO'];
    const index = Math.round((angle % 360) / 45) % 8;
    
    return directions[index];
}

/**
 * Geeft een beschrijvende naam voor de zijde van het gebouw
 * @param {number} angle - Hoek in graden (0-360)
 * @returns {string} Omschrijving van de zijde (Noord, Oost, Zuid, West, etc.)
 */
function getSideDescription(angle) {
    // In screencoördinaten: 0°=Oost, 90°=Zuid, 180°=West, 270°=Noord
    const sides = ['Oost', 'Zuid-Oost', 'Zuid', 'Zuid-West',
                    'West', 'Noord-West', 'Noord', 'Noord-Oost'];
    const index = Math.round((angle % 360) / 45) % 8;
    
    return sides[index];
}

function distancePointToSegment(p, p1, p2) {
    const x = p.x, y = p.y;
    const x1 = p1.x, y1 = p1.y;
    const x2 = p2.x, y2 = p2.y;

    const A = x - x1;
    const B = y - y1;
    const C = x2 - x1;
    const D = y2 - y1;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;

    let xx, yy;
    if (param < 0) {
        xx = x1; yy = y1;
    } else if (param > 1) {
        xx = x2; yy = y2;
    } else {
        xx = x1 + param * C;
        yy = y1 + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
}


function loadHistory(){
  return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
}
function saveHistory(arr){
  localStorage.setItem(HISTORY_KEY, JSON.stringify(arr));
}
function addToHistory(hit){
  let history = loadHistory();
  history = history.filter(h => h.id !== hit.id); // dubbele eruit
  history.unshift(hit);                          // bovenaan
  if(history.length > 10) history = history.slice(0,10);
  saveHistory(history);
}

function getFormData() {
  const params = {}; 
  jQuery("#gegevens-form input, #gegevens-form select, #gegevens-form textarea").each(function() {
    const id = jQuery(this).attr("id");
    if (id) {
      params[id] = jQuery(this).val() || "";
    }
  });

  return params;
}

function clearForm() {
    jQuery("#gegevens-form input, #gegevens-form select, #gegevens-form textarea").each(function() {
        jQuery(this).val("");
    });
}

//var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
//var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//  return new bootstrap.Tooltip(tooltipTriggerEl)
//})